import RegistrationForm from "../components/RegistrationForm";

function Home() {
  return <RegistrationForm />;
}
export default Home;
